/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class UpdatePolicyV2Request extends models.CreatePolicyV2Request {
    getFixupPrototypeFunction() { return UpdatePolicyV2Request.fixupPrototype; }

    static newInstance(model: Partial<UpdatePolicyV2Request>): UpdatePolicyV2Request {
        let obj = Object.assign(new UpdatePolicyV2Request(), model);
        UpdatePolicyV2Request.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<UpdatePolicyV2Request>): UpdatePolicyV2Request {
        if (!model) return null;
        return UpdatePolicyV2Request.newInstance(<UpdatePolicyV2Request> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: UpdatePolicyV2Request) {
        if (!obj) return;

        models.UpdatePolicyV2Request.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: UpdatePolicyV2Request): boolean {
        if (models.CreatePolicyV2Request.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, UpdatePolicyV2Request.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
